import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitService {

  constructor(private http:HttpClient) { }


  GetRecord(_legacyToken?:String):Observable<Array<Unit_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Unit").pipe(
      map(data=>{
        return data as Array<Unit_Interface>
      })
    )
  }

  GetSingle(TokenOrId:any, id?:Number):Observable<Unit_Interface>{
    const unitId = typeof id === 'number' ? id : Number(TokenOrId);
    return this.http.get(environment.BaseUrl + "Daro/Unit/GetSingle?id="+unitId).pipe(
      map(data=>{
        return data as Unit_Interface
      })
    )
  }

  AddUnit(model: Unit_Interface,Token?:String):Observable<Unit_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      quantity_id:model.quantity_id,
      del:false,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Unit/Add",body,{headers}).pipe(
        map(data=>{
          return data as Unit_Interface
        })
      )

  }

  EditUnit(model: Unit_Interface,Token?:String):Observable<Unit_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Unit/Edit",body,{headers}).pipe(
        map(data=>{
          return data as Unit_Interface
        })
      )

  }

  DeleteUnit(id:number,Token?:String):Observable<Unit_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Unit/Delete?id="+id).pipe(
        map(data=>{
          return data as Unit_Interface
        })
      )

  }

  GetDataEntity(TokenOrId:any,id?:number):Observable<Array<Unit_Interface>>{
    const dataEntityId = typeof id === 'number' ? id : Number(TokenOrId);
    return this.http.get(environment.BaseUrl + "Daro/Unit/GetDataEntity?id="+dataEntityId).pipe(
      map(data=>{
        return data as Array<Unit_Interface>
      })
    )
  }


}
